import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, UserRound, Store, FileText, MessageSquareQuote, QrCode, LogOut, Menu, X, Users, ScrollText, Wallet, Smartphone, ShieldCheck, Package, Tags, Bell, Image, Hash, Info, Megaphone } from "lucide-react";
import { LogoMark } from "@/components/LogoMark";

const iconMap = {
  "Overview": LayoutDashboard,
  "My GI profile": UserRound,
  "Marketplace": Store,
  "Apply for GI Authorised User": FileText,
  "Buyer requests": MessageSquareQuote,
  "My orders": Package,
  "Authenticity QR": QrCode,
  "Admin overview": ShieldCheck,
  "Sellers": Users,
  "Authorised users": Users,
  "Submissions": ScrollText,
  "GI catalog": Tags,
  "Contact messages": MessageSquareQuote,
  "Orders": Package,
  "Categories": Tags,
  "Notifications": Bell,
  "Banners": Image,
  "Home ad": Megaphone,
  "Gallery": Image,
  "Counters": Hash,
  "About us": Info,
  "Contact info": MessageSquareQuote,
  "Meet the makers": Users,
  "Return policy": ScrollText,
  "Fees": Wallet,
  "OTP / Twilio": Smartphone,
};

export function Layout({ user, setUser, nav, children }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const logout = () => {
    localStorage.removeItem("tv_token");
    setUser(null);
    navigate("/");
  };
  const isAdmin = user.role === "admin";
  return (
    <div className="app-shell">
      <aside className={open ? "sidebar open" : "sidebar"}>
        <div className="side-brand">
          <LogoMark small />
          <span>
            GI Bharat
            <small>{isAdmin ? "Admin console" : "GI Bharat platform"}</small>
          </span>
          <button className="icon-btn mobile-only" onClick={() => setOpen(false)} data-testid="close-menu-button" aria-label="Close menu">
            <X size={20} />
          </button>
        </div>
        <div className="side-label">{isAdmin ? "Operations" : "Workspace"}</div>
        <nav>
          {nav.map(({ to, label }) => {
            const Icon = iconMap[label] || LayoutDashboard;
            return (
              <NavLink
                onClick={() => setOpen(false)}
                data-testid={`nav-${label.toLowerCase().replaceAll(" ", "-").replaceAll("/", "-")}`}
                key={to}
                to={to}
                end={to === "/" || to === "/admin"}
              >
                <Icon size={18} />
                {label}
              </NavLink>
            );
          })}
        </nav>
        <div className="side-bottom">
          <div className="help-box">
            <span>{isAdmin ? "Manage the network" : "Need help?"}</span>
            <b>{isAdmin ? "Set fees, approvals, OTP" : "Talk to True Vision"}</b>
          </div>
          <button className="logout" onClick={logout} data-testid="logout-button">
            <LogOut size={17} /> Sign out
          </button>
        </div>
      </aside>
      <div className="main">
        <header className="topbar">
          <button className="icon-btn mobile-only" onClick={() => setOpen(true)} data-testid="open-menu-button" aria-label="Open menu">
            <Menu size={21} />
          </button>
          <div className="crumb">
            {isAdmin ? "Admin console" : "Member workspace"} <span>/</span> {user.name}
          </div>
          <div className="top-actions">
            <div className="avatar">{user.name.slice(0, 1).toUpperCase()}</div>
            <div className="user-name">
              {user.name}
              <small>{user.role === "admin" ? "Administrator" : user.role === "buyer" ? "Buyer" : user.verified ? "Verified seller" : "Authorised user"}</small>
            </div>
          </div>
        </header>
        {children}
      </div>
    </div>
  );
}
